import useAccessTokenStore from 'auth/lib/useAccessTokenStore';
import { onSessionExpired } from 'wb-reddit/app/app';
import { REFRESH_TOKEN_URI } from 'wb-reddit/src/app/common/utils';

export async function refreshTokenWrapper(handler: (accessToken?: string) => Promise<Response>): Promise<any> {
	let retries = 0;

	let res = await handler();

	if (res.status === 496 && retries < 1) {
		retries += 1;
		const newAccessToken = await useAccessTokenStore.getState().refreshAccessToken(
			REFRESH_TOKEN_URI,
			onSessionExpired,
		)();

		res = await handler(newAccessToken);
	}

	const data = await res.json();

	return data;
}
